import { useMemo } from 'react';
import { Params, useLocation, useMatch, useNavigate } from 'react-router-dom';
import qs, { ParsedQs } from 'qs';

const parts = {
    origin: window.location.origin,
    protocol: window.location.protocol,
    host: window.location.host,
    hostname: window.location.hostname,
    port: window.location.port
};

type UseLocationState<T = ParsedQs> = [
    {
        origin: string;
        protocol: string;
        host: string;
        hostname: string;
        port: string;
        pathname: string;
        search: string;
        hash: string;
        query: T;
        params: Params<string>;
        match: boolean;
    },
    (l: string) => void,
    (l: string) => void
];

export const useLocationState = <T extends ParsedQs>(path = { path: '/' }): UseLocationState<T> => {
    const location = useLocation();
    const query = useMemo(
        () => qs.parse(location.search.replace(/^\?/, ''), { arrayLimit: 1000 }) as T,
        [location.search]
    );
    const navigate = useNavigate();
    const match = useMatch(path);
    return [
        {
            ...parts,
            ...location,
            query,
            params: match?.params || {},
            match: !!match
        },
        navigate,
        (l: string) => navigate(l, { replace: true })
    ];
};
